<template>
  <div>
    <modal-cart />
    <modal-finding />
    <modal-order-successful />
    <app-mobile-drawer />
    <app-header />
    <main class="main">
      <slot />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppMobileDrawer from '@/components/common/AppMobileDrawer'
import AppHeader from '@/components/common/AppHeader'
import AppFooter from '@/components/common/AppFooter'
import ModalCart from '@/components/modal/ModalCart'
import ModalFinding from '@/components/modal/ModalFinding'
import ModalOrderSuccessful from '@/components/modal/ModalOrderSuccessful'

export default {
  name: 'MainTemplate',
  components: {
    AppMobileDrawer,
    AppHeader,
    AppFooter,
    ModalCart,
    ModalFinding,
    ModalOrderSuccessful
  }
}
</script>